import { DamEcoPrimaryCondenser } from '~/providers/types/damEcoMode';

/** Faixa aceita pelo backend para os atrasos de estágio, em minutos inteiros. */
export const STAGE_DELAY_MIN = 0;
export const STAGE_DELAY_MAX = 29;

/** Faixa aceita pelo backend para o setpoint, em °C. */
export const SETPOINT_MIN = 0;
export const SETPOINT_MAX = 30;

/** Faixa aceita pelo backend para as histereses, em °C (precisam ser maiores que o mínimo). */
export const HYSTERESIS_MIN = 0;
export const HYSTERESIS_MAX = 5;

/** Faixa aceita pelo backend para o LTI, em °C; além dela, o LTI precisa ficar abaixo do setpoint. */
export const LTI_MIN = 0;
export const LTI_MAX = 30;
/** Ao ligar o LTI sem valor digitado, ele abre este tanto abaixo do setpoint, em °C. */
export const LTI_DEFAULT_BELOW_SETPOINT = 2;

/** Ventilação inicial e final aceitas pelo backend: até 8 horas, em minutos. */
export const VENT_TIME_MAX = 480;

export const PRIMARY_CONDENSER_OPTIONS: { value: DamEcoPrimaryCondenser; labelKey: string }[] = [
  { value: 'COND1', labelKey: 'ecoSimplificadoCondensadora1' },
  { value: 'COND2', labelKey: 'ecoSimplificadoCondensadora2' },
];
